import gql from 'graphql-tag';

const GET_REPORTING_ORGANIZATIONS = gql`
  query getReportingOrganizations {
    organizations {
      id
      type
    }
  }
`;

export default GET_REPORTING_ORGANIZATIONS;
